import React from 'react';
import {observer} from "mobx-react";
import {CheckboxComponent} from "../../basic-components/checkbox/checkbox.component";
import {
    IFlightSearchControllerViewModel,
} from "../../services/flight-search/flight-search-controller/flight-search-controller-view-model.interface";
import {PsoUserOptionsEnum} from "../../services/flight-search/flight-search-controller/pso.enums";


interface PsoUserOptionComponentProps {
    optionValue: PsoUserOptionsEnum;
    searchController: IFlightSearchControllerViewModel;
    className?: string;
}

export const PsoUserOptionComponent: React.FC<PsoUserOptionComponentProps> = observer((props) => {
    const searchController = props.searchController;
    const psoMarket = searchController.psoMarket;
    if(!psoMarket) {
        return null;
    }

    const onChanged = (isChecked: boolean) => {
        if(isChecked) {
            searchController.psoUserOption = props.optionValue;
        } else {
            searchController.psoUserOption = PsoUserOptionsEnum.None;
        }
    }

    const getLabel = () => {
        return psoMarket.translations.getPsoUserOptionTranslation(props.optionValue);
    }


    return (
        <CheckboxComponent checked={searchController.psoUserOption === props.optionValue}
                           isReadOnly={true}
                           label={getLabel()}
                           onChange={onChanged}/>

    )
});
